export default __webpack_public_path__ + "static/media/tarifa.17bc613d.png";